import { render, staticRenderFns } from "./Fonts.vue?vue&type=template&id=b089d56c"
import script from "./Fonts.vue?vue&type=script&lang=js"
export * from "./Fonts.vue?vue&type=script&lang=js"
import style0 from "./Fonts.vue?vue&type=style&index=0&id=b089d56c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports